import { IIconProps } from "@/components/icons/interface";
import { useTheme } from "@/contexts/theme";

const EyeIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color || "currentColor";
  const { currentTheme } = useTheme();
  const hp = currentTheme === "hp-client";
  const strokeWidth = hp ? 1.5 : 2;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-eye-icon lucide-eye"
    >
      <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

export { EyeIcon };
